var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-page',{attrs:{"title":'Admin Home Page'},scopedSlots:_vm._u([{key:"main",fn:function(){return [_c('iframe',{attrs:{"width":"100%","height":"650","src":_vm.getIframeLink(),"frameborder":"0"}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }